import React from 'react';

const TTPLoader = ({ cssClass = '' }) => (
  <div className={`ripple_loading ${cssClass || ''}`}>
    <img src={'/img/Ripple-1s-150px.svg'} alt="" />
  </div>
);

export default TTPLoader;
